import React from "react";
import { checkoutUrl, heroImage, pricing } from "../data/landing";
import { OfferBox } from "./OfferBox";
import { DollarPriceNotice } from "./DollarPriceNotice";
import { PreviewRing } from "./PreviewRing";
import { Guarantee } from "./Guarantee";
type HeroProps = {
  onCheckout: () => void;
};
export function Hero({
  onCheckout
}: HeroProps) {
  return <div className="w" data-id="element-85" data-mp="4jm7fs1z99so">
      <div className="hero" data-id="element-86" data-mp="1297a3xzwwp6o">
        <div className="heroimg" data-id="element-87" data-mp="128fsjr35grze">
          <img src={heroImage.src} alt={heroImage.alt} width={1000} height={1000} loading="eager" decoding="async" data-id="element-88" data-mp="127ef5fynvtei" />
        </div>
        <div className="col" data-id="element-89" data-mp="sb1a5lxo1t4g">
          <div className="offer" data-id="element-90" data-mp="sa9s7dwzrtwn">
            <span className="b" data-id="element-91" data-mp="sde2mt11vlvr">
              <span className="m" data-id="element-92" data-mp="ncgk2fc4optq">✦ Lançamento</span>
              <span className="d" data-id="element-93" data-mp="nbosrgpkde99">Economize {pricing.savings}</span>
            </span>
          </div>
          <h1 className="tit" data-id="element-94" data-mp="3d2tp5bt8kofl">600 fichas ilustradas de exercícios para idosos, prontas para imprimir e aplicar</h1>
          <OfferBox data-id="element-95" data-mp="384jtz17ihntz" />
          <a className="btn" href={checkoutUrl} onClick={onCheckout} data-id="element-96" data-mp="3j8sdfvbir9n7">
            Quero minhas 600 fichas
          </a>
          <DollarPriceNotice data-id="element-97" data-mp="3o7vkflb27pxt" />
          <PreviewRing data-id="element-98" data-mp="3o73no75q7m5y" />
          <Guarantee data-id="element-99" data-mp="3o5j1b4tkf9j6" />
        </div>
      </div>
    </div>;
}